// @flow
'use strict';

import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosCte from './selecao_todos_cte';
import { Input } from '../../../../../../common/input';

export default function CamposComponente() {
  return (
      <fieldset className="grupo-download-lista">
        <legend>Componentes do Valor da Prestação de Serviço</legend>
        <p className="instrucao-em-titulo">
          A lista retornará uma linha para cada componente do valor da prestação de serviço.
        </p>

        <Row>
          <Col md={ 12 }>
            <FormSection name="componente">
              <SelecaoTodosCte nomes={ ['componente'] }
                               titulo="Componentes do Valor da Prestação de Serviço"/>

              <div className="grupo-checkbox">
                <Input name="componenteNome" label="Nome" checkbox/>
                <Input name="componenteValor" label="Valor" checkbox/>
              </div>
            </FormSection>
          </Col>
        </Row>
      </fieldset>
  );
}
